import { useEffect, useMemo } from 'react';

import { useAppDispatch, useAppSelector } from 'hooks';
import { getIsLoading } from 'theme/selectors';
import { domain } from 'utils/domainService';
import { setDomain } from 'theme/themeSlice';
import { fetchTenant } from 'theme/thunks';
import Loading from 'components/Loading';
import { useCurrentUser } from 'hooks';

enum ThemeType {
  paya = 'theme-paya',
  freightx = 'theme-freightx',
  invoicecloud = 'theme-ic',
}

const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const dispatch = useAppDispatch();

  const { logoutRedirect } = useCurrentUser();

  const isLoading: boolean = useAppSelector(getIsLoading);

  const currentDomain: string = useMemo(() => domain(), []);

  useEffect(() => {
    dispatch(fetchTenant(logoutRedirect));
    dispatch(setDomain(currentDomain));
    document.documentElement.classList.add(ThemeType[currentDomain] ?? 'smart');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDomain]);

  if (isLoading) {
    return <Loading />;
  }

  return <div>{children}</div>;
};

export default ThemeProvider;
